<template>
  <div id="userForm" class="m-t-10">
    <div class="columns is-centered">
      <div class="column is-6">
        <div class="box">
          <form class="container" @submit.prevent="createUser">
            <fieldset :disabled="loading">
              <h3 class="title is-3">Create User</h3>

              <b-field label="Mail*">
                <b-input type="email" required v-model="user.email" required-class="has-text-danger"></b-input>
              </b-field>

              <b-field label="Password*">
                <b-input type="password" v-model="pwd" pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%?&])[A-Za-z\d@$!%*?&]{8,}$" validation-message="Password must contains minimum 8 characters, one uppercase letter, one lowercase letter, one number and one special character" required-class="has-text-danger" password-reveal></b-input>
              </b-field>

              <div class="form-inline">
                <div class="nameInput">
                  <b-field label="Last Name">
                    <b-input type="text" v-model="user.last_name"></b-input>
                  </b-field>
                </div>
                <div class="nameInput">
                  <b-field label="First Name">
                    <b-input type="text" v-model="user.first_name"></b-input>
                  </b-field>
                </div>
              </div>

              <b-field label="Company">
                <b-input type="text" v-model="user.company"></b-input>
              </b-field>

              <b-field label="Lang">
                <b-select v-model="user.lang" placeholder="Select a lang">
                    <option v-for="lang in langs" :value="lang.value" :key="lang.value">
                      {{lang.name}}
                    </option>
                </b-select>
              </b-field>

              <b-field label="Cell">
                <b-input type="tel" v-model="user.cell" validation-message="Cell number must contains country calling code" pattern="\+(9[976]\d|8[987530]\d|6[987]\d|5[90]\d|42\d|3[875]\d|
  2[98654321]\d|9[8543210]|8[6421]|6[6543210]|5[87654321]|4[987654310]|3[9643210]|2[70]|7|1)\d{1,14}$" title="Renseigner l'indicatif international" placeholder="+33..."></b-input>
              </b-field>

              <b-field>
                  <b-switch v-model="user.cell_certified">Cell certified</b-switch>
              </b-field>

              <b-field>
                  <b-switch v-model="user.admin">Admin</b-switch>
              </b-field>

              <b-field label="Enterprise Id*" v-if="user.admin === false">
                <b-input type="number" required-class="has-text-danger" required v-model.number="user.enterprise_id" min="1"></b-input>
              </b-field>

              <b-field label="Add pack" v-if="user.admin">
                <b-taginput :value="user.pack" @input="user.pack = $event.map(Number)" ellipsis :before-adding="beforeAdding"> </b-taginput>
              </b-field>

              <b-field>
                <b-switch v-model="sendEmail">Send Mail</b-switch>
              </b-field>

              <button class="button is-primary" type="submit">
                <b-icon icon="check"></b-icon>
                <span>Create</span>
              </button>
            </fieldset>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import LoginForm from './LoginForm.vue'

  function initialState() {
    return {
      user: {
        username: '',
        last_name:'',
        first_name:'',
        email: '',
        company:'',
        cell: '',
        lang: null,
        cell_certified: false,
        admin: true,
        enterprise_id: 0,
        pack: [],
      },

      sendEmail: false,
      pwd: '',
      loading: false,
    }
  }

  export default {
    name: 'Users',

    data() {
      return {
        ...initialState(),
        access_token: '',
        langs: [
          {
            name:"FR",
            value:"fr",
          },
          {
            name:"EN",
            value:"en",
          },
          {
            name:"ES",
            value:"es",
          },
          {
            name:"NL",
            value:"nl",
          },
          {
            name:"IT",
            value:"it",
          },
          {
            name:"DL",
            value:"dl",
          },
          {
            name:"PE",
            value:"pe",
          },
          {
            name:"PT",
            value:"pt",
          },
          {
            name:"RO",
            value:"ro",
          },
          {
            name:"SV",
            value:"sv",
          },
          {
            name:"TR",
            value:"tr",
          },
          {
            name:"CS",
            value:"cs",
          },
          {
            name:"SL",
            value:"sl",
          },
        ],
      }
    },

    mounted() {
      this.$buefy.modal.open({
        parent: this,
        component: LoginForm,
        hasModalCard: true,
        canCancel: false,
        events: {
          connect: access_token => {
            this.access_token = access_token
          }
        }
      });
    },

    methods: {

      async createUser() {
        this.loading = true;
        this.user.username = this.user.email

        if (this.user.admin) {
          this.user.enterprise_id = 0;
        } else {
          this.user.pack = [];
        }

        if (this.user.lang == '') {
          this.user.lang = 'fr'
        }

        try {
          const res = await axios.put('https://api.admin.weproov.com/v1/user', {...this.user, pwd: this.pwd, send_email: this.sendEmail}, {
          // const res = await axios.put('https://bvjfek5n80.execute-api.eu-west-1.amazonaws.com/test/user', {...this.user, pwd: this.pwd, send_email: this.sendEmail}, {
            headers: {
              'Authorization': this.access_token,
              'Content-Type': 'application/json', 
              'Accept': '*/*'
            }
          });

          if (res.status == 200) {
            this.success();
            this.resetForm();
            window.scrollTo(0,0);
          } 

        } catch(e) {
          this.danger();
          window.scrollTo(0,0);
        } finally {
          this.loading = false
        }
      },
 
      resetForm() {
        let initialData = initialState();

        for (let prop in initialData) {
          this[prop] = initialData[prop]
        }
      },

      danger() {
        this.$buefy.toast.open({
          duration: 3000,
          message: `An error occured during user creation`,
          type: 'is-danger'
        })
      },

      success() {
        this.$buefy.toast.open({
          duration: 3000,
          message: `The user has been created`,
          type: 'is-success'
        })
      },

      beforeAdding(n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
      }
    }
  }
</script>

<style scoped>
  .m-t-10 {
    margin-top: 10px;
  }


  ul {
    padding: 0;
    margin: 0;
    margin-bottom: 5px;
  }

  li {
    display: inline-block;
    padding-top: 10px; 
    padding-bottom: 10px;
    margin: 5px;
  }

  .form-inline {
    display: flex;
    flex-direction: row;
    align-content: space-around;
  }

  .nameInput {
    display: flex;
    flex-direction: column;
    margin-right: 10px;
    margin-bottom: 10px;
  }

</style>